/// <reference types="./project.d.mts" />
import * as $endpoints from "../../../app_config/app_config/endpoints.mjs";
import * as $sentry from "../../../app_config/sentry.mjs";
import * as $project from "../../../common/data/project.mjs";
import * as $file from "../../../ds/web/browser/file.mjs";
import * as $global from "../../../ds/web/javascript/global.mjs";
import * as $fetch from "../../../gleam_fetch/gleam/fetch.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $request from "../../../gleam_http/gleam/http/request.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $level from "../../../grille_pain/grille_pain/toast/level.mjs";
import * as $effect from "../../../lustre/lustre/effect.mjs";
import * as $state from "../../data/model/state.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $ask from "../../frontend/ask.mjs";
import * as $error from "../../frontend/error.mjs";
import * as $middleware from "../../frontend/middleware.mjs";
import { Ok, toList, makeError } from "../../gleam.mjs";

const FILEPATH = "src/frontend/effects/project.gleam";

export function fetch_projects(_) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          return $function.tap(
            undefined,
            (_) => {
              let _pipe = $ask.to(new $ask.Heimdall(), toList(["projects"]));
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.expect(
                _pipe$1,
                $decode.list($project.decoder()),
              );
              let _pipe$3 = $ask.notify(
                _pipe$2,
                (p) => {
                  return dispatch(
                    new $msg.Project(new $msg.ApiReturnedProjects(p, false)),
                  );
                },
              );
              return $ask.run(_pipe$3);
            },
          );
        },
      );
    },
  );
}

export function update_project(state, id, only_status) {
  return $middleware.require_access_token(
    (access_token) => {
      let $ = $list.key_find(state.projects, id);
      if ($ instanceof Ok) {
        let project = $[0];
        let _block;
        if (only_status) {
          _block = toList(["projects", project.id, "status"]);
        } else {
          _block = toList(["projects", project.id]);
        }
        let at = _block;
        return $effect.from(
          (dispatch) => {
            return $function.tap(
              undefined,
              (_) => {
                let _pipe = $ask.to(new $ask.Heimdall(), at);
                let _pipe$1 = $ask.with$(
                  _pipe,
                  $json.object(toList([["project", $project.encode(project)]])),
                );
                let _pipe$2 = $ask.via(_pipe$1, new $http.Patch());
                let _pipe$3 = $ask.bearing(_pipe$2, access_token);
                let _pipe$4 = $ask.expect(
                  _pipe$3,
                  $decode.at(toList(["project"]), $project.decoder()),
                );
                let _pipe$5 = $ask.notify(
                  _pipe$4,
                  (p) => {
                    return dispatch(
                      new $msg.Project(
                        new $msg.ApiReturnedProjects(toList([p]), true),
                      ),
                    );
                  },
                );
                return $ask.run(_pipe$5);
              },
            );
          },
        );
      } else {
        return $effect.none();
      }
    },
  );
}

export function toggle_project_collaborator(state, project_id, user_id) {
  let project = $list.key_find(state.projects, project_id);
  return $middleware.require_access_token(
    (access_token) => {
      if (project instanceof Ok) {
        let project$1 = project[0];
        return $effect.from(
          (dispatch) => {
            return $function.tap(
              undefined,
              (_) => {
                let new$ = $project.toggle_collaborator(project$1, user_id);
                let _pipe = $ask.to(
                  new $ask.Heimdall(),
                  toList(["projects", project_id]),
                );
                let _pipe$1 = $ask.bearing(_pipe, access_token);
                let _pipe$2 = $ask.via(_pipe$1, new $http.Patch());
                let _pipe$3 = $ask.with$(
                  _pipe$2,
                  $json.object(toList([["project", $project.encode(new$)]])),
                );
                let _pipe$4 = $ask.expect(
                  _pipe$3,
                  $decode.at(toList(["project"]), $project.decoder()),
                );
                let _pipe$5 = $ask.notify(
                  _pipe$4,
                  (p) => {
                    return dispatch(
                      new $msg.Project(
                        new $msg.ApiReturnedProjects(toList([p]), true),
                      ),
                    );
                  },
                );
                return $ask.run(_pipe$5);
              },
            );
          },
        );
      } else {
        return $effect.none();
      }
    },
  );
}

export function delete_project(project_id) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (_) => {
          return $function.tap(
            undefined,
            (_) => {
              let _pipe = $ask.to(
                new $ask.Heimdall(),
                toList(["projects", project_id]),
              );
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.via(_pipe$1, new $http.Delete());
              return $ask.run(_pipe$2);
            },
          );
        },
      );
    },
  );
}

function download_file(archive, project_) {
  let file_name = $project.name(project_) + ".zip";
  let _pipe = $file.download(file_name, archive);
  return $promise.map(_pipe, (_) => { return new Ok(undefined); });
}

export function download(project_, toast_id) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          return $function.tap(
            undefined,
            (_) => {
              let url = $endpoints.heimdall();
              let url$1 = $string.join(
                toList([url, "projects", project_.id, "export"]),
                "/",
              );
              let $ = $request.to(url$1);
              if (!($ instanceof Ok)) {
                throw makeError(
                  "let_assert",
                  FILEPATH,
                  "frontend/effects/project",
                  103,
                  "download",
                  "Pattern match failed, no pattern matched the value.",
                  {
                    value: $,
                    start: 3193,
                    end: 3233,
                    pattern_start: 3204,
                    pattern_end: 3215
                  }
                )
              }
              let request = $[0];
              let _pipe = request;
              let _pipe$1 = $request.set_method(_pipe, new $http.Get());
              let _pipe$2 = $request.set_header(
                _pipe$1,
                "authorization",
                "Bearer " + access_token,
              );
              let _pipe$3 = $fetch.send(_pipe$2);
              let _pipe$4 = $promise.try_await(_pipe$3, $fetch.read_bytes_body);
              let _pipe$5 = $promise.map(
                _pipe$4,
                (_capture) => {
                  return $result.map_error(
                    _capture,
                    (var0) => { return new $error.FetchError(var0); },
                  );
                },
              );
              let _pipe$6 = $promise.map_try(
                _pipe$5,
                (_capture) => {
                  return $error.internal_error(
                    _capture,
                    "Error while exporting project",
                  );
                },
              );
              let _pipe$7 = $promise.map_try(
                _pipe$6,
                (res) => { return new Ok(res.body); },
              );
              let _pipe$8 = $promise.try_await(
                _pipe$7,
                (_capture) => { return download_file(_capture, project_); },
              );
              let _pipe$9 = $promise.map(_pipe$8, $sentry.capture_error);
              return $promise.map(
                _pipe$9,
                (response) => {
                  dispatch(new $msg.ApplicationRequestedToHideToast(toast_id));
                  return $global.set_timeout(
                    1000,
                    () => {
                      let _block;
                      if (response instanceof Ok) {
                        let _pipe$10 = "File downloaded successfully!";
                        _block = ((_capture) => {
                          return new $msg.ApplicationRequestedToDisplayToast(
                            new $level.Success(),
                            _capture,
                          );
                        })(_pipe$10);
                      } else {
                        let _pipe$10 = "Impossible to download the file. Please, retry later.";
                        _block = ((_capture) => {
                          return new $msg.ApplicationRequestedToDisplayToast(
                            new $level.Error(),
                            _capture,
                          );
                        })(_pipe$10);
                      }
                      let _pipe$10 = _block;
                      return dispatch(_pipe$10);
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
